import Toast from '../components/Toast';

/** File-count toast behavior for storage-limit checks. */
export function notifyFileCountLimits(count) {
    if (count > 100) {
        Toast.fire({ title: `File Count ${count}, limit exeeded.`, icon: 'error' });
    } else if (count === 100) {
        Toast.fire({ title: `File Count ${count}, limit reached`, icon: 'error' });
    } else if (count >= 90 && count <= 99) {
        Toast.fire({ title: `File Count ${count}, approaching limit`, icon: 'warning' });
    }
}
